import { TooltipProps } from '@mui/material'
import React from 'react'
import CustomTooltip from 'src/designSystem/CustomTooltip'

// MUI's tooltip margin leaves ~4px between the arrow tip and the anchor; close it so the arrow meets the indicator.
const POPPER_PROPS: TooltipProps['PopperProps'] = {
  modifiers: [{ name: 'offset', options: { offset: [0, -4] } }],
}

const IndicatorTooltip = (props: Omit<TooltipProps, 'placement' | 'PopperProps'>) => (
  <CustomTooltip {...props} placement="top" PopperProps={POPPER_PROPS} />
)

export default IndicatorTooltip
